<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="titlepage" id="bk">
<h1 class="bk"><span aria-label="iii" class="page" id="piii" role="doc-pagebreak"></span><span class="sm">SUN</span> <span class="sm">RA’S</span></h1>
<h1 class="bk" style="margin-top:0;">Chicago</h1>
<h1 class="bk1">Afrofuturism &amp; the City</h1>
<p class="bkau"><span class="sm">WILLIAM</span> <span class="sm">SITES</span></p>
<p class="bkpub">The University of Chicago Press</p>
<p class="bkpub1"><span class="sm">CHICAGO</span> <span class="sm">&amp;</span> <span class="sm">LONDON</span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-sites-0004.vue?31404e62